import { EditUserProfileModal } from './EditUserProfileModal';
import { LogoutConfirmation } from './LogoutConfirmation';
import {
  RecoveryCpfForm,
  RecoveryError,
  RecoveryKycVerification,
  RecoveryPhoneForm,
  RecoverySuccess,
  RecoveryValidating,
} from './recovery';
import { RegistrationExitConfirmation } from './RegistrationExitConfirmation';
import { UserAddressForm } from './UserAddressForm';
import { UserLoginForm } from './UserLoginForm';
import { UserProfile } from './UserProfile';
import { UserRegisterForm } from './UserRegisterForm';

export {
  LogoutConfirmation,
  RecoveryCpfForm,
  RecoveryError,
  RecoveryKycVerification,
  RecoveryPhoneForm,
  RecoverySuccess,
  RecoveryValidating,
  RegistrationExitConfirmation,
  UserAddressForm,
  UserLoginForm,
  UserProfile,
  UserRegisterForm,
  EditUserProfileModal,
};
